import { AnnouncementData } from '@ypp-portal/models/announcement/announcementData';
import firebase from 'firebase/app';
import 'firebase/firestore';

export class AnnouncementDataConverter
  implements firebase.firestore.FirestoreDataConverter<AnnouncementData>
{
  toFirestore(modelObject: AnnouncementData): AnnouncementData {
    return {
      ...modelObject,
      content: modelObject.content.replace(/\n/g, '\\n'),
    };
  }
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<AnnouncementData>
  ): AnnouncementData {
    const data = snapshot.data();
    return {
      ...data,
      content: data.content.replace(/\\n/g, '  \n'), // Weird markdown thing
    };
  }
}
